import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import voucherQueryKeys from './voucherQueryKeys'
import { updateVoucher } from '../service/voucherService'
import { Voucher } from '../../../pages/reporting/vouchers/types'
import { queryClient } from '../../../services/api/queryClient'
import { showSuccessMessage } from '../../../utils/message'

export const useCtxUpdateVoucher = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { notification } = App.useApp()

  if (!companyId) {
    throw new Error('Company ID is required for vouchers.')
  }

  return useMutation({
    mutationKey: voucherQueryKeys.list({ companyId }),
    mutationFn: ({ data, voucherId }: { data: FormData; voucherId: Voucher['id'] }) =>
      updateVoucher(data, voucherId, companyId),
    onSuccess() {
      showSuccessMessage()
      return queryClient.invalidateQueries({
        queryKey: voucherQueryKeys.lists()
      })
    },
    onError(error) {
      notification.error({ message: error.message })
    }
  })
}
